export interface NotebookTag {
    key: string;
    value: string;
    isLabel?: boolean;
}


export const NotebookTagKeys = {
    application: 'Application',
    module: 'Module',
    page: 'Page',
    rga: 'RGA',
    partNo: 'Part No',
    query: 'Query',
    section: 'Section',
    slug: 'Slug',
    customerNo: 'Customer No',
    ncrCode: 'NCR Code',
    ncrActionGroupId: 'NCR Action Group Id',
}

export const NotebookTagModules = {
    default: 'Operator Panel',
    bizInventory: "BizInventory",
    lookup: "Lookup",
    warranty: "Warranty & Return",
    sales: "Sales",
    bizPrint: "BizPrint",
    clients_platform: "Clients Platform",
    taskNote: "Task & Note Management",
    bizCrm: "BizCRM",
    ncr: "Non-Conformance Reports",
    notifications: "Notifications",
    dashboards: "Dashboards",
    purchasing: "Purchasing",
    timeTracker: "Time Tracker",
    bizFile: "BizFile",
    bizForm: "Form management",
    bizPoint: "BizPoint",
    support: "Support",
}

export const NotebookTagApplication = 'operator-platform'

export const NotebookTagPages = {
    operatorProfile: 'operator-profile',
    partnerProfile: 'partner-profile',
    printHub: 'print-hub',
    printLabels: 'print-labels',
    printCatalogue: 'print-catalogue',
    printBrochure: 'print-brochure',
    printPackingList: 'print-packing-list',
    dashboard: 'dashboard',
    lookupNexusSearch: 'lookup-nexus-search',
    notificationManagement: 'notification-management',
    lookupProductInformation: 'lookup-product-information',
    lookupCompareList: 'lookup-compare-list',
    lookupAnalytics: 'lookup-analytics',
    competitorPriceReport: 'competitor-price-report',
    warrantyAndReturnRequests: 'warranty-and-return-requests',
    warrantyAndReturnInformation: 'warranty-and-return-information',
    warrantyAndReturnSettingsStatuses: 'warranty-and-return-settings-statuses',
    warrantyAndReturnSettingsProcess: 'warranty-and-return-settings-process',
    drivers: 'drivers',
    taxesList: 'taxesList',
    taxesRegions: 'taxesRegions',
    reports: 'reports',
    contentBlogList: 'content-blogs-list',
    contentBlogInformation: 'content-blog-information',
    contentVideosList: 'content-videos-list',
    contentVideoInformation: 'content-video-information',
    customersList: 'customers-list',
    customersMembers: 'customers-members',
    customersMembersActive: 'customers-members-active',
    customersMembersInactive: 'customers-members-inactive',
    customersMembersPassive: 'customers-members-passive',
    operatorsList: 'operators-list',
    operatorsGroups: 'operators-groups',
    operatorsGroupAccessLevels: 'operators-group-access-levels',
    operatorsDashboards: 'operators-dashboards',
    salesQuotes: 'sales-quotes',
    salesSalesOrders: 'sales-sales-orders',
    salesBackOrders: 'sales-back-orders',
    salesInvoices: 'sales-invoices',
    salesCredits: 'sales-credits',
    salesPersonDashboard: 'sales-person-dashboard',
    accountingInvoices: 'accounting-invoices',
    accountingAccountReceivables: 'accounting-account-receivables',
    accountingOnlinePaymentTransactions: 'accounting-online-payment-transactions',
    userNotificationsList: 'user-notifications-list',
    userNotificationsAccessLevels: 'user-notifications-access-levels',
    userNotificationsSubscriptions: 'user-notifications-subscriptions',
    userPlatformList: 'user-platform-list',
    userPlatformLiveHomepages: 'user-platform-live-homepages',
    userPlatformPhoneHomepage: 'user-platform-phone-homepage',
    userPlatformWebHomepage: 'user-platform-web-homepage',
    userPlatformThemeManagementPhone: 'user-platform-theme-management-phone',
    userPlatformThemeManagementWeb: 'user-platform-theme-management-web',
    userPlatformBannerManagement: 'user-platform-banner-management',
    userPlatformContentManagement: 'user-platform-content-management',
    userPlatformDynamicPagesList: 'user-platform-dynamic-pages-list',
    userPlatformDynamicPageSingle: 'user-platform-dynamic-page-single',
    settingsOrganization: 'settings-organization',
    settingsPersonal: 'settings-personal',
    giftCardsList: 'gift-cards-list',
    giftCardsCategories: 'gift-cards-categories',
    priceMatrixList: 'price-matrix-list',
    priceMatrixCustomers: 'price-matrix-customers',
    settingsExport: 'settings-export',
    settingsImport: 'settings-import',
    promotionsList: 'promotions-list',
    promotionInformation: 'promotion-information',
    regions: 'regions',
    territories: 'territories',
    salesPersonAccessLevels: 'salesPersonAccessLevels',
    partnership: "partnership",
    damageControlMissingProducts: 'damage-control-missing-products',
    damageControlTransactions: 'damage-control-transactions',
    productsList: 'products-list',
    productInformation: 'product-information',
    productsTagsList: 'products-tags-list',
    productsTagInformation: 'products-tag-information',
    productsRelationTypes: 'products-relation-types',
    productsManageSuggestions: 'products-manage-suggestions',
    productsFastConnection: 'products-fast-connection',
    bulkPriceChangeDashboard: 'bulk-price-change-dashboard',
    bulkPriceChangeReport: 'bulk-price-change-report',
    bulkPriceChange: 'bulk-price-change',
    inventoryAdjustmentList: 'inventory-adjustment-list',
    inventoryAdjustmentItems: 'inventory-adjustment-items',
    inventoryAdjustmentReport: 'inventory-adjustment-report',
    inventoryAdjustmentInformation: 'inventory-adjustment-information',
    inventoryAdjustmentBulkAvailabilityChange: 'inventory-adjustment-bulk-availability-change',
    inventoryTransferBatches: 'inventory-transfer-batches',
    inventoryTransferBatchInformation: 'inventory-transfer-batch-information',
    inventoryTransferPostTransfer: 'inventory-transfer-post-transfer',
    inventoryTransferReturnInformation: 'inventory-transfer-return-information',
    inventoryTransferHistoryList: 'inventory-transfer-history-list',
    inventoryTransferHistoryItems: 'inventory-transfer-history-items',
    inventoryTransferHistoryInformation: 'inventory-transfer-history-information',
    shippingFeesList: 'shipping-fees-list',
    shippingFeesSettings: 'shipping-fees-settings',
    shippingFeesCompanies: 'shipping-fees-companies',
    shippingFeesReports: 'shipping-fees-reports',
    shippingFeesRegionRates: 'shipping-fees-region-rates',
    shippingFeesShippingRates: 'shipping-fees-shipping-rates',
    customerProfile: 'customer-profile',
    customerAddresses: 'customer-addresses',
    customerLoginLogs: 'customer-login-logs',
    customerPromotions: 'customer-promotions',
    customerNotes: 'customer-notes',
    customerPriceMatrix: 'customer-price-matrix',
    customerAccountingAvailableCredits: 'customer-accounting-available-credits',
    customerSalesQuotes: 'customer-sales-quotes',
    customerSalesQuoteInformation: 'customer-sales-quote-information',
    customerSalesSalesOrders: 'customer-sales-sales-orders',
    customerSalesSalesOrderInformation: 'customer-sales-sales-order-information',
    customerSalesBackOrders: 'customer-sales-back-orders',
    customerSalesBackOrderInformation: 'customer-sales-back-order-information',
    customerSalesInvoices: 'customer-sales-invoices',
    customerSalesInvoiceInformation: 'customer-sales-invoice-information',
    customerSalesCredits: 'customer-sales-credits',
    customerSalesCreditInformation: 'customer-sales-credit-information',
    customerSalesShoppingCart: 'customer-sales-shopping-cart',
    customerSalesActiveCards: 'customer-sales-active-cards',
    customerCardSummaryCreditCards: 'customer-card-summary-credit-cards',
    customerCardSummaryGiftCards: 'customer-card-summary-gift-cards',
    customerShippingFeesList: 'customer-shipping-fees-list',
    customerShippingFeesSettings: 'customer-shipping-fees-settings',
    surveyList: 'survey-list',
    surveyPreview: 'survey-preview',
    purchaseList: 'purchase-list',
    vendorsList: 'vendors-list',
    vendorProfile: 'vendor-profile',
    vendorAccountInfo: 'vendor-account-info',
    vendorAddresses: 'vendor-addresses',
    vendorNotes: 'vendor-notes',
    vendorProducts: 'vendor-products',
    vendorPurchaseList: 'vendor-purchase-list',
    vendorPurchaseOrders: 'vendor-purchase-orders',
    vendorPurchaseHistory: 'vendor-purchase-history',
    vendorPurchaseOrderSingle: 'vendor-purchase-order-single',
    vendorPurchaseHistorySingle: 'vendor-purchase-history-single',
    notebook: 'notebook',
    ncrList: 'ncr-list',
    ncrNotes: 'ncr-notes',
    ncrTasks: 'ncr-tasks',
    ncrInformation: 'ncr-information',
    ncrSettings: 'ncr-settings',
    formsManagementList: 'forms-management-list',
    formsManagementResponses: 'forms-management-responses',
    bizPointLoyaltyDashboard: 'biz-point-loyalty-dashboard',
    bizPointLoyaltyBuy: 'biz-point-loyalty-buy',
    bizPointLoyaltyRules: 'biz-point-loyalty-rules',
    bizPointLoyaltyCustomers: 'biz-point-loyalty-customers',
    bizPointLoyaltySettings: 'biz-point-loyalty-settings',
    bizPointAdminReviewQueue: 'biz-point-admin-review-queue',
    bizPointAdminWalletOperations: 'biz-point-admin-wallet-operations',
    bizPointAdminBusinessConfig: 'biz-point-admin-business-config',
    bizPointAdminLiabilityReport: 'biz-point-admin-liability-report',
    bizPointAdminAuditLog: 'biz-point-admin-audit-log',
    bizPointAdminPurchaseConfirm: 'biz-point-admin-purchase-confirm',
    supportContactUsMessages: 'support-contact-us-messages',
    customerFormResponses: 'customer-form-responses',
    settingsIndustryManagement: 'settings-industry-management',
    productsCategoryManagement: 'products-category-management',
    productsCodeTypes: 'products-code-types',
    productsShareRules: 'products-share-rules',
    manageProductProperties: 'manage-product-properties',
    priceLevelsConfig: 'price-levels-config',
    lostSalesAnalytics: 'lost-sales-analytics',
    settingsPartnersManagement: "settings-partners-management",
    customerAccountReceivableTransactions: "customer-account-receivable-transactions",
}

const notebookTags = {
    default: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
    ] as NotebookTag[],
    operatorProfile: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.operatorProfile}, {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    partnerProfile: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.partnerProfile}, {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    printHub: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.printHub}, {key: NotebookTagKeys.module, value: NotebookTagModules.bizPrint, isLabel: true},
    ] as NotebookTag[],
    printLabels: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.printLabels}, {key: NotebookTagKeys.module, value: NotebookTagModules.bizPrint, isLabel: true},
    ] as NotebookTag[],
    printCatalogue: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.printCatalogue}, {key: NotebookTagKeys.module, value: NotebookTagModules.bizPrint, isLabel: true},
    ] as NotebookTag[],
    printBrochure: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.printCatalogue}, {key: NotebookTagKeys.module, value: NotebookTagModules.bizPrint, isLabel: true},
    ] as NotebookTag[],
    printPackingList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.printPackingList}, {key: NotebookTagKeys.module, value: NotebookTagModules.bizPrint, isLabel: true},
    ] as NotebookTag[],
    dashboard: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.dashboard}, {key: NotebookTagKeys.module, value: NotebookTagModules.dashboards, isLabel: true},
    ] as NotebookTag[],
    notificationManagement: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.notificationManagement},
        {key: NotebookTagKeys.module, value: NotebookTagModules.notifications, isLabel: true},
    ] as NotebookTag[],
    lookupNexusSearch: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.lookupNexusSearch},
        {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    lookupProductInformation: (partNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.lookupProductInformation},
        {key: NotebookTagKeys.partNo, value: partNo.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    lookupCompareList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.lookupCompareList}, {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    warrantyAndReturnRequests: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.module, value: NotebookTagModules.warranty, isLabel: true},
        {key: NotebookTagKeys.page, value: NotebookTagPages.warrantyAndReturnRequests},
    ] as NotebookTag[],
    warrantyAndReturnInformation: (id: any, rga: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.module, value: NotebookTagModules.warranty, isLabel: true},
        {key: NotebookTagKeys.page, value: NotebookTagPages.warrantyAndReturnInformation},
        {key: NotebookTagKeys.query, value: id.toString()},
        {key: NotebookTagKeys.rga, value: rga.toString(), isLabel: true},
    ] as NotebookTag[],
    warrantyAndReturnSettingsStatuses: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.warrantyAndReturnSettingsStatuses},
        {key: NotebookTagKeys.module, value: NotebookTagModules.warranty, isLabel: true},
    ] as NotebookTag[],
    warrantyAndReturnSettingsProcess: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.warrantyAndReturnSettingsProcess},
        {key: NotebookTagKeys.module, value: NotebookTagModules.warranty, isLabel: true},
    ] as NotebookTag[],
    drivers: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.drivers},
        {key: NotebookTagKeys.module, value: NotebookTagModules.warranty, isLabel: true},
    ] as NotebookTag[],
    taxesList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.taxesList},
        {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    taxesRegions: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.taxesRegions},
        {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    reports: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.reports},
        {key: NotebookTagKeys.module, value: NotebookTagModules.dashboards, isLabel: true},
    ] as NotebookTag[],
    contentBlogsList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.contentBlogList},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    contentBlogInformation: (slug: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.contentBlogInformation},
        {key: NotebookTagKeys.query, value: slug.toString()},
        {key: NotebookTagKeys.slug, value: slug.toString(), isLabel: true},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    contentVideosList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.contentVideosList},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    contentVideoInformation: (slug: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.contentVideoInformation},
        {key: NotebookTagKeys.query, value: slug.toString()},
        {key: NotebookTagKeys.slug, value: slug.toString(), isLabel: true},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    customersList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customersList},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    customersMembers: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customersMembers},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    customersActiveMembers: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customersMembersActive}, {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    customersInactiveMembers: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customersMembersInactive}, {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    customersPassiveMembers: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customersMembersPassive}, {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    operatorsList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.operatorsList}, {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    operatorsGroups: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.operatorsGroups}, {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    operatorsGroupAccessLevels: (groupId: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.operatorsGroupAccessLevels},
        {key: NotebookTagKeys.query, value: groupId.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    operatorsDashboards: (groupId?: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.module, value: NotebookTagModules.dashboards, isLabel: true},
        {key: NotebookTagKeys.page, value: NotebookTagPages.operatorsDashboards},
        ...(groupId ? [{key: NotebookTagKeys.query, value: groupId.toString()},] : []),
    ] as NotebookTag[],
    salesQuotes: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.salesQuotes}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    salesSalesOrders: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.salesSalesOrders}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    salesBackOrders: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.salesBackOrders}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    salesInvoices: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.salesInvoices}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    salesCredits: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.salesCredits}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    salesPersonDashboard: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.salesPersonDashboard}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    accountingInvoices: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.accountingInvoices}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    accountingAccountReceivables: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.accountingAccountReceivables}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    accountingOnlinePaymentTransactions: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.accountingOnlinePaymentTransactions},
        {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    userNotificationsList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.userNotificationsList}, {key: NotebookTagKeys.module, value: NotebookTagModules.notifications, isLabel: true},
    ] as NotebookTag[],
    userNotificationsAccessLevels: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.userNotificationsAccessLevels}, {key: NotebookTagKeys.module, value: NotebookTagModules.notifications, isLabel: true},
    ] as NotebookTag[],
    userNotificationsSubscriptions: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.userNotificationsSubscriptions}, {key: NotebookTagKeys.module, value: NotebookTagModules.notifications, isLabel: true},
    ] as NotebookTag[],
    userPlatformList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.userPlatformList}, {key: NotebookTagKeys.module, value: NotebookTagModules.clients_platform, isLabel: true},
    ] as NotebookTag[],
    userPlatformLiveHomepages: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.userPlatformLiveHomepages}, {key: NotebookTagKeys.module, value: NotebookTagModules.clients_platform, isLabel: true},
    ] as NotebookTag[],
    userPlatformPhoneHomepage: (query: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.userPlatformPhoneHomepage},
        {key: NotebookTagKeys.query, value: query.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.clients_platform, isLabel: true},
    ] as NotebookTag[],
    userPlatformWebHomepage: (query: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.userPlatformWebHomepage},
        {key: NotebookTagKeys.query, value: query.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.clients_platform, isLabel: true},
    ] as NotebookTag[],
    userPlatformThemeManagementPhone: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.userPlatformThemeManagementPhone}, {key: NotebookTagKeys.module, value: NotebookTagModules.clients_platform, isLabel: true},
    ] as NotebookTag[],
    userPlatformThemeManagementWeb: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.userPlatformThemeManagementWeb}, {key: NotebookTagKeys.module, value: NotebookTagModules.clients_platform, isLabel: true},
    ] as NotebookTag[],
    userPlatformBannerManagement: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.userPlatformBannerManagement}, {key: NotebookTagKeys.module, value: NotebookTagModules.clients_platform, isLabel: true},
    ] as NotebookTag[],
    userPlatformContentManagement: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.userPlatformContentManagement}, {key: NotebookTagKeys.module, value: NotebookTagModules.clients_platform, isLabel: true},
    ] as NotebookTag[],
    userPlatformDynamicPagesList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.userPlatformDynamicPagesList}, {key: NotebookTagKeys.module, value: NotebookTagModules.clients_platform, isLabel: true},
    ] as NotebookTag[],
    userPlatformDynamicPageSingle: (pageId: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.userPlatformDynamicPageSingle},
        {key: NotebookTagKeys.query, value: pageId.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.clients_platform, isLabel: true},
    ] as NotebookTag[],
    settingsOrganization: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.settingsOrganization}, {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    settingsPersonal: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.settingsPersonal}, {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    giftCardsList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.giftCardsList}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    giftCardsCategories: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.giftCardsCategories}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    priceMatrixList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.priceMatrixList}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    priceMatrixCustomers: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.priceMatrixCustomers}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    settingsExport: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.settingsExport}, {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    settingsImport: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.settingsImport}, {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    promotionsList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.promotionsList}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    promotionInformation: (promotionId: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.promotionInformation},
        {key: NotebookTagKeys.query, value: promotionId.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    regions: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.regions},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    territories: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.territories},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    partnership: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.partnership}, {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    priceLevelsConfig: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.priceLevelsConfig},
        {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    damageControlMissingProducts: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.damageControlMissingProducts}, {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    damageControlTransactions: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.damageControlTransactions}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    salesPersonAccessLevels: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.salesPersonAccessLevels},
        {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    productsList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.productsList}, {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    productInformation: (id: string | number, section?: string) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.productInformation},
        {key: NotebookTagKeys.query, value: id.toString()},
        {key: NotebookTagKeys.section, value: section?.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    productsTagsList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.productsTagsList}, {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    productsTagInformation: (id: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.productsTagInformation},
        {key: NotebookTagKeys.query, value: id.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    productsRelationTypes: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.productsRelationTypes}, {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    productsManageSuggestions: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.productsManageSuggestions}, {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    productsFastConnection: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.productsFastConnection}, {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    bulkPriceChangeDashboard: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.bulkPriceChangeDashboard}, {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    bulkPriceChangeReport: (id: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.bulkPriceChangeReport},
        {key: NotebookTagKeys.query, value: id.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    bulkPriceChangeNewBulkPrice: (id: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.bulkPriceChange},
        {key: NotebookTagKeys.query, value: id.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    inventoryAdjustmentList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.inventoryAdjustmentList}, {key: NotebookTagKeys.module, value: NotebookTagModules.bizInventory, isLabel: true},
    ] as NotebookTag[],
    inventoryAdjustmentItems: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.inventoryAdjustmentItems}, {key: NotebookTagKeys.module, value: NotebookTagModules.bizInventory, isLabel: true},
    ] as NotebookTag[],
    inventoryAdjustmentReport: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.inventoryAdjustmentReport}, {key: NotebookTagKeys.module, value: NotebookTagModules.bizInventory, isLabel: true},
    ] as NotebookTag[],
    inventoryAdjustmentInformation: (id: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.inventoryAdjustmentInformation},
        {key: NotebookTagKeys.query, value: id.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.bizInventory, isLabel: true},
    ] as NotebookTag[],
    inventoryAdjustmentBulkAvailabilityChange: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.inventoryAdjustmentBulkAvailabilityChange}, {key: NotebookTagKeys.module, value: NotebookTagModules.bizInventory, isLabel: true},
    ] as NotebookTag[],
    inventoryTransferBatches: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.inventoryTransferBatches}, {key: NotebookTagKeys.module, value: NotebookTagModules.bizInventory, isLabel: true},
    ] as NotebookTag[],
    inventoryTransferBatchInformation: (id: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.inventoryTransferBatchInformation},
        {key: NotebookTagKeys.query, value: id.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.bizInventory, isLabel: true},
    ] as NotebookTag[],
    inventoryTransferPostTransfer: (id: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.inventoryTransferPostTransfer},
        {key: NotebookTagKeys.query, value: id.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.bizInventory, isLabel: true},
    ] as NotebookTag[],
    inventoryTransferReturnInformation: (fromWarehouseId: string | number, toWarehouseId: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.inventoryTransferReturnInformation},
        {key: NotebookTagKeys.query, value: `${fromWarehouseId}-${toWarehouseId}`}, {key: NotebookTagKeys.module, value: NotebookTagModules.bizInventory, isLabel: true},
    ] as NotebookTag[],
    inventoryTransferHistoryList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.inventoryTransferHistoryList},
        {key: NotebookTagKeys.module, value: NotebookTagModules.bizInventory, isLabel: true},
    ] as NotebookTag[],
    inventoryTransferHistoryItems: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.inventoryTransferHistoryItems},
        {key: NotebookTagKeys.module, value: NotebookTagModules.bizInventory, isLabel: true},
    ] as NotebookTag[],
    inventoryTransferHistoryInformation: (id: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.inventoryTransferHistoryInformation},
        {key: NotebookTagKeys.query, value: id.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.bizInventory, isLabel: true},
    ] as NotebookTag[],
    shippingFeesList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.shippingFeesList},
        {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    shippingFeesSettings: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.shippingFeesSettings},
        {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    shippingFeesCompanies: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.shippingFeesCompanies},
        {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    shippingFeesReports: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.shippingFeesReports},
        {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    shippingFeesRegionRates: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.shippingFeesRegionRates},
        {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    shippingFeesShippingRates: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.shippingFeesShippingRates},
        {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerProfile: (customerNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerProfile},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    customerAddresses: (customerNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerAddresses},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true},
        {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerLoginLogs: (customerNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerLoginLogs},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    customerPromotions: (customerNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerPromotions},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerNotes: (customerNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerNotes},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    customerPriceMatrixList: (customerNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerPriceMatrix},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerAccountingAvailableCredits: (customerNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerAccountingAvailableCredits},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerSalesQuotes: (customerNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerSalesQuotes},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerSalesQuoteInformation: (customerNo: string | number, orderId: number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerSalesQuoteInformation},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true},
        {key: NotebookTagKeys.query, value: orderId.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerSalesSalesOrders: (customerNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerSalesSalesOrders},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerSalesSalesOrderInformation: (customerNo: string | number, orderId: number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerSalesSalesOrderInformation},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true},
        {key: NotebookTagKeys.query, value: orderId.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerSalesBackOrders: (customerNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerSalesBackOrders},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerSalesBackOrderInformation: (customerNo: string | number, orderId: number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerSalesBackOrderInformation},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true},
        {key: NotebookTagKeys.query, value: orderId.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerSalesInvoices: (customerNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerSalesInvoices},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerSalesInvoiceInformation: (customerNo: string | number, orderId: number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerSalesInvoiceInformation},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true},
        {key: NotebookTagKeys.query, value: orderId.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerSalesCredits: (customerNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerSalesCredits},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerSalesCreditInformation: (customerNo: string | number, orderId: number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerSalesCreditInformation},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true},
        {key: NotebookTagKeys.query, value: orderId.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerSalesShoppingCart: (customerNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerSalesShoppingCart},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerSalesActiveCards: (customerNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerSalesActiveCards},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerCardSummaryCreditCards: (customerNo: string | number, cardId: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerCardSummaryCreditCards},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true},
        {key: NotebookTagKeys.query, value: cardId.toString()},
        {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerCardSummaryGiftCards: (customerNo: string | number, cardId: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerCardSummaryGiftCards},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true},
        {key: NotebookTagKeys.query, value: cardId.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerShippingFeesList: (customerNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerShippingFeesList},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    customerShippingFeesSettings: (customerNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerShippingFeesSettings},
        {key: NotebookTagKeys.customerNo, value: customerNo.toString(), isLabel: true}, {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
    surveyList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.surveyList}, {key: NotebookTagKeys.module, value: NotebookTagModules.clients_platform, isLabel: true},
    ] as NotebookTag[],
    surveyPreview: (surveyId: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.surveyPreview},
        {key: NotebookTagKeys.query, value: surveyId.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.clients_platform, isLabel: true},
    ] as NotebookTag[],
    purchaseList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.purchaseList}, {key: NotebookTagKeys.module, value: NotebookTagModules.purchasing, isLabel: true},
    ] as NotebookTag[],
    vendorsList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.vendorsList}, {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    vendorProfile: (vendorNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.vendorProfile},
        {key: NotebookTagKeys.query, value: vendorNo.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    vendorAccountInfo: (vendorNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.vendorAccountInfo},
        {key: NotebookTagKeys.query, value: vendorNo.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    vendorAddresses: (vendorNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.vendorAddresses},
        {key: NotebookTagKeys.query, value: vendorNo.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    vendorNotes: (vendorNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.vendorNotes},
        {key: NotebookTagKeys.query, value: vendorNo.toString()}, {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    vendorProducts: (vendorNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.vendorProducts},
        {key: NotebookTagKeys.query, value: vendorNo.toString()},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    vendorPurchaseList: (vendorNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.vendorPurchaseList},
        {key: NotebookTagKeys.query, value: vendorNo.toString()},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    vendorPurchaseOrders: (vendorNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.vendorPurchaseOrders},
        {key: NotebookTagKeys.query, value: vendorNo.toString()},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    vendorPurchaseHistory: (vendorNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.vendorPurchaseHistory},
        {key: NotebookTagKeys.query, value: vendorNo.toString()},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    vendorPurchaseOrderSingle: (vendorNo: string | number, orderNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.vendorPurchaseOrderSingle},
        {key: NotebookTagKeys.query, value: `${vendorNo}:${orderNo}`},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    vendorPurchaseHistorySingle: (vendorNo: string | number, historyNo: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.vendorPurchaseHistorySingle},
        {key: NotebookTagKeys.query, value: `${vendorNo}:${historyNo}`},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    notebook: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.notebook},
        {key: NotebookTagKeys.module, value: NotebookTagModules.taskNote, isLabel: true},
    ] as NotebookTag[],
    ncrList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.ncrList},
        {key: NotebookTagKeys.module, value: NotebookTagModules.ncr, isLabel: true},
    ] as NotebookTag[],
    ncrNotes: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.ncrNotes},
        {key: NotebookTagKeys.module, value: NotebookTagModules.ncr, isLabel: true},
    ] as NotebookTag[],
    ncrTasks: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.ncrTasks}, {key: NotebookTagKeys.module, value: NotebookTagModules.ncr, isLabel: true},
    ] as NotebookTag[],
    ncrInformation: (id?: string | number, code?: string) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.module, value: NotebookTagModules.ncr, isLabel: true},
        {key: NotebookTagKeys.page, value: NotebookTagPages.ncrInformation},
        ...(!!id ? [{key: NotebookTagKeys.query, value: id.toString()},] : []),
        ...(!!code ? [{key: NotebookTagKeys.ncrCode, value: code, isLabel: true},] : []),
    ] as NotebookTag[],
    ncrInformationActionGroup: (id: number, actionGroupId: number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.ncrInformation},
        {key: NotebookTagKeys.query, value: id.toString()},
        {key: NotebookTagKeys.ncrActionGroupId, value: actionGroupId.toString()},
        {key: NotebookTagKeys.module, value: NotebookTagModules.ncr, isLabel: true},
    ] as NotebookTag[],
    ncrSettings: (tab: any) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.module, value: NotebookTagModules.ncr, isLabel: true},
        {key: NotebookTagKeys.page, value: NotebookTagPages.ncrSettings},
        {key: NotebookTagKeys.query, value: tab},
    ] as NotebookTag[],
    formsManagementList: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.formsManagementList},
        {key: NotebookTagKeys.module, value: NotebookTagModules.bizForm, isLabel: true},
    ] as NotebookTag[],
    formsManagementResponses: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.formsManagementResponses},
        {key: NotebookTagKeys.module, value: NotebookTagModules.bizForm, isLabel: true},
    ] as NotebookTag[],
    bizPointLoyaltyDashboard: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.bizPointLoyaltyDashboard},
        {key: NotebookTagKeys.module, value: NotebookTagModules.bizPoint, isLabel: true},
    ] as NotebookTag[],
    bizPointLoyaltyBuy: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.bizPointLoyaltyBuy},
        {key: NotebookTagKeys.module, value: NotebookTagModules.bizPoint, isLabel: true},
    ] as NotebookTag[],
    bizPointLoyaltyRules: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.bizPointLoyaltyRules},
        {key: NotebookTagKeys.module, value: NotebookTagModules.bizPoint, isLabel: true},
    ] as NotebookTag[],
    bizPointLoyaltyCustomers: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.bizPointLoyaltyCustomers},
        {key: NotebookTagKeys.module, value: NotebookTagModules.bizPoint, isLabel: true},
    ] as NotebookTag[],
    supportContactUsMessages: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.supportContactUsMessages},
        {key: NotebookTagKeys.module, value: NotebookTagModules.support, isLabel: true},
    ] as NotebookTag[],
    bizPointLoyaltySettings: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.bizPointLoyaltySettings},
        {key: NotebookTagKeys.module, value: NotebookTagModules.bizPoint, isLabel: true},
    ] as NotebookTag[],
    bizPointAdminReviewQueue: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.bizPointAdminReviewQueue},
        {key: NotebookTagKeys.module, value: NotebookTagModules.bizPoint, isLabel: true},
    ] as NotebookTag[],
    bizPointAdminWalletOperations: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.bizPointAdminWalletOperations},
        {key: NotebookTagKeys.module, value: NotebookTagModules.bizPoint, isLabel: true},
    ] as NotebookTag[],
    bizPointAdminBusinessConfig: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.bizPointAdminBusinessConfig},
        {key: NotebookTagKeys.module, value: NotebookTagModules.bizPoint, isLabel: true},
    ] as NotebookTag[],
    bizPointAdminLiabilityReport: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.bizPointAdminLiabilityReport},
        {key: NotebookTagKeys.module, value: NotebookTagModules.bizPoint, isLabel: true},
    ] as NotebookTag[],
    bizPointAdminAuditLog: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.bizPointAdminAuditLog},
        {key: NotebookTagKeys.module, value: NotebookTagModules.bizPoint, isLabel: true},
    ] as NotebookTag[],
    bizPointAdminPurchaseConfirm: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.bizPointAdminPurchaseConfirm},
        {key: NotebookTagKeys.module, value: NotebookTagModules.bizPoint, isLabel: true},
    ] as NotebookTag[],
    customerFormResponses: (customerId: string | number) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerFormResponses},
        {key: NotebookTagKeys.module, value: NotebookTagModules.bizForm, isLabel: true},
        {key: NotebookTagKeys.customerNo, value: customerId.toString(), isLabel: true},
    ] as NotebookTag[],
    settingsIndustryManagement: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.settingsIndustryManagement},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    settingsPartnersManagement: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.settingsPartnersManagement},
        {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
    ] as NotebookTag[],
    productsCategoryManagement: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.productsCategoryManagement},
        {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    productsCodeTypes: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.productsCodeTypes},
        {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    productsShareRules: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.productsShareRules},
        {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    manageProductProperties: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.manageProductProperties},
        {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    settingsProductPropertyManagement: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.settingsIndustryManagement},
        {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    lookupAnalytics: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.lookupAnalytics},
        {key: NotebookTagKeys.module, value: NotebookTagModules.dashboards, isLabel: true},
    ] as NotebookTag[],
    competitorPriceReport: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.competitorPriceReport},
        {key: NotebookTagKeys.module, value: NotebookTagModules.lookup, isLabel: true},
    ] as NotebookTag[],
    lostSalesAnalytics: [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.lostSalesAnalytics},
        {key: NotebookTagKeys.module, value: NotebookTagModules.dashboards, isLabel: true},
    ] as NotebookTag[],
    customerAccountReceivableTransactions: (code: string | undefined) => [
        {key: NotebookTagKeys.application, value: NotebookTagApplication},
        {key: NotebookTagKeys.page, value: NotebookTagPages.customerAccountReceivableTransactions},
        {key: NotebookTagKeys.query, value: code ?? '', isLabel: true},
        {key: NotebookTagKeys.module, value: NotebookTagModules.sales, isLabel: true},
    ] as NotebookTag[],
}

export default notebookTags;


type NotebookTags = typeof notebookTags;

export type CustomerNoteTagConfigurator = (container: NotebookTags) => NotebookTag[];

export interface CustomerNoteSectionVisibility {
    profile: boolean;
    addresses: boolean;
    loginLogs: boolean;
    promotions: boolean;
    priceMatrix: boolean;
    availableCredits: boolean;
    accountReceivableTransactions: boolean;
    paymentMethods: boolean;
    shippingFeesList: boolean;
    shippingFeesSettings: boolean;
    formResponses: boolean;
    notesPage: boolean;
}

interface CustomerNoteSectionDefinition {
    key: keyof CustomerNoteSectionVisibility;
    configurator: (customerCode: string, customerId: number) => CustomerNoteTagConfigurator;
}

const customerNoteSections: CustomerNoteSectionDefinition[] = [
    {key: 'profile', configurator: (customerCode) => (tags) => tags.customerProfile(customerCode)},
    {key: 'addresses', configurator: (customerCode) => (tags) => tags.customerAddresses(customerCode)},
    {key: 'loginLogs', configurator: (customerCode) => (tags) => tags.customerLoginLogs(customerCode)},
    {key: 'promotions', configurator: (customerCode) => (tags) => tags.customerPromotions(customerCode)},
    {key: 'priceMatrix', configurator: (customerCode) => (tags) => tags.customerPriceMatrixList(customerCode)},
    {key: 'availableCredits', configurator: (customerCode) => (tags) => tags.customerAccountingAvailableCredits(customerCode)},
    {key: 'accountReceivableTransactions', configurator: (customerCode) => (tags) => tags.customerAccountReceivableTransactions(customerCode)},
    {key: 'paymentMethods', configurator: (customerCode) => (tags) => tags.customerSalesActiveCards(customerCode)},
    {key: 'shippingFeesList', configurator: (customerCode) => (tags) => tags.customerShippingFeesList(customerCode)},
    {key: 'shippingFeesSettings', configurator: (customerCode) => (tags) => tags.customerShippingFeesSettings(customerCode)},
    {key: 'formResponses', configurator: (_customerCode, customerId) => (tags) => tags.customerFormResponses(customerId)},
    {key: 'notesPage', configurator: (customerCode) => (tags) => tags.customerNotes(customerCode)},
];

/**
 * Maps operator access-level packages to customer note section visibility (mirrors customer sidebar gates).
 */
export const getCustomerNoteSectionVisibility = (packages: {
    base: {customerDetails: boolean; customerLoginLogs: boolean};
    sales: {
        manageCustomerAddresses: boolean;
        customerPromotions: boolean;
        customerPriceMatrices: boolean;
        customerAvailableCredits: boolean;
        customerAccountReceivableTransactions: boolean;
        manageCustomerPaymentMethods: boolean;
        customerFreightFees: boolean;
        customerFreeFreightFees: boolean;
    };
    bizForm: {formResponsesList: boolean};
    taskNote: {notes: boolean};
}): CustomerNoteSectionVisibility => ({
    profile: packages.base.customerDetails,
    addresses: packages.sales.manageCustomerAddresses,
    loginLogs: packages.base.customerLoginLogs,
    promotions: packages.sales.customerPromotions,
    priceMatrix: packages.sales.customerPriceMatrices,
    availableCredits: packages.sales.customerAvailableCredits,
    accountReceivableTransactions: packages.sales.customerAccountReceivableTransactions,
    paymentMethods: packages.sales.manageCustomerPaymentMethods,
    shippingFeesList: packages.sales.customerFreightFees,
    shippingFeesSettings: packages.sales.customerFreeFreightFees,
    formResponses: packages.bizForm.formResponsesList,
    notesPage: packages.taskNote.notes,
});

/**
 * Tag configurators for customer-scoped notes shown on the customer Notes page
 * (profile, addresses, payment methods, etc. — excluding orders, invoices, and card summaries).
 */
export const getCustomerAggregateNoteTagConfigurators = (
    customerCode: string,
    customerId: number,
    visibility: CustomerNoteSectionVisibility,
): CustomerNoteTagConfigurator[] =>
    customerNoteSections
        .filter(({key}) => visibility[key])
        .map(({configurator}) => configurator(customerCode, customerId));

/**
 * Resolved tag groups for API calls (e.g. getPageNotes).
 */
export const getCustomerAggregateNoteTagGroups = (
    customerCode: string,
    customerId: number,
    visibility: CustomerNoteSectionVisibility,
): NotebookTag[][] =>
    getCustomerAggregateNoteTagConfigurators(customerCode, customerId, visibility).map(
        (configurator) => configurator(notebookTags),
    );

export type VendorNoteTagConfigurator = (container: NotebookTags) => NotebookTag[];

export interface VendorNoteSectionVisibility {
    accountInfo: boolean;
    purchaseOrders: boolean;
    purchaseHistory: boolean;
    notesPage: boolean;
}

interface VendorNoteSectionDefinition {
    key: keyof VendorNoteSectionVisibility;
    configurator: (vendorCode: string) => VendorNoteTagConfigurator;
}

const vendorNoteSections: VendorNoteSectionDefinition[] = [
    {key: 'accountInfo', configurator: (vendorCode) => (tags) => tags.vendorAccountInfo(vendorCode)},
    {key: 'purchaseOrders', configurator: (vendorCode) => (tags) => tags.vendorPurchaseOrders(vendorCode)},
    {key: 'purchaseHistory', configurator: (vendorCode) => (tags) => tags.vendorPurchaseHistory(vendorCode)},
    {key: 'notesPage', configurator: (vendorCode) => (tags) => tags.vendorNotes(vendorCode)},
];

/**
 * Maps operator access-level packages to vendor note section visibility.
 */
export const getVendorNoteSectionVisibility = (packages: {
    base: {viewVendorAccountInfo: boolean; viewVendorNotes: boolean};
    purchasing: {viewPurchaseOrders: boolean; viewPurchaseHistory: boolean};
}): VendorNoteSectionVisibility => ({
    accountInfo: packages.base.viewVendorAccountInfo,
    purchaseOrders: packages.purchasing.viewPurchaseOrders,
    purchaseHistory: packages.purchasing.viewPurchaseHistory,
    notesPage: packages.base.viewVendorNotes,
});

/**
 * Tag configurators for vendor-scoped notes aggregation.
 */
export const getVendorAggregateNoteTagConfigurators = (
    vendorCode: string,
    visibility: VendorNoteSectionVisibility,
): VendorNoteTagConfigurator[] =>
    vendorNoteSections
        .filter(({key}) => visibility[key])
        .map(({configurator}) => configurator(vendorCode));

/**
 * Resolved tag groups for API calls (e.g. getPageNotes) on the vendor Notes page.
 * Prefer {@link getVendorNotesAggregateQueryTags} + page filtering when one request is enough.
 */
export const getVendorAggregateNoteTagGroups = (
    vendorCode: string,
    visibility: VendorNoteSectionVisibility,
): NotebookTag[][] =>
    getVendorAggregateNoteTagConfigurators(vendorCode, visibility).map(
        (configurator) => configurator(notebookTags),
    );

/**
 * Shared query tags for one ListByTags call across vendor page scopes.
 * Notes store application + query(vendor code) + module on every vendor page tag group;
 * ListByTags matches notes that contain at least these tags (page differs per section).
 */
export const getVendorNotesAggregateQueryTags = (vendorCode: string): NotebookTag[] => [
    {key: NotebookTagKeys.application, value: NotebookTagApplication},
    {key: NotebookTagKeys.query, value: vendorCode.toString()},
    {key: NotebookTagKeys.module, value: NotebookTagModules.default, isLabel: true},
];

/**
 * Page tag values the vendor Notes list is allowed to show (mirrors section access gates).
 */
export const getVendorAllowedNotePageValues = (
    visibility: VendorNoteSectionVisibility,
): string[] => {
    const pages: string[] = [];
    if (visibility.accountInfo) {
        pages.push(NotebookTagPages.vendorAccountInfo);
    }
    if (visibility.purchaseOrders) {
        pages.push(NotebookTagPages.vendorPurchaseOrders);
    }
    if (visibility.purchaseHistory) {
        pages.push(NotebookTagPages.vendorPurchaseHistory);
    }
    if (visibility.notesPage) {
        pages.push(NotebookTagPages.vendorNotes);
    }
    return pages;
};
